export default function Header() {
  return (
    <header className="no-select text-6xl py-2 bg-primaryDark shadow-header">
      <div>AimAI</div>
    </header>
  );
}
